import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from '../layout/images/responsive';
import styles from './photos.scss';

class Photos extends Component {
  render() {
    const { photos } = this.props;

    const photoElements = photos.map((photo) => {
      if (photo.fields === undefined) { return null; }

      return (
        <ResponsiveImage key={photo.sys.id} image={photo}/>
      )
    });

    return (
      <section className={styles.photos}>
        {photoElements}
      </section>
    );
  }
}

Photos.propTypes = {
  photos: PropTypes.array.isRequired
}

export default Photos;



// WEBPACK FOOTER //
// ./src/components/photos/photos.jsx